<template>
	<div class="contact">
		<div class="title-box">
			<img src="@/assets/images/title_contact.png"/>
		</div>
		<div class="main">
			<div class="in">
				<!-- <img class="title" src="@/assets/images/title_contact_1.png"/> -->
				<p class="label">公众号</p>
				<p class="text">鹿优选商城</p>
				<p class="label">官方邮箱</p>
				<p class="text" style="margin-bottom: 0.7rem;">kf@luyouxuan.com</p>
				<img class="tel" src="@/assets/images/tel.png"/>
			</div>
			
			<img class="pic" src="@/assets/images/pic_contact.png"/>
			<div class="bg"></div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {}
		},
		mounted() {},
		methods: {},

	}
</script>

<style scoped lang="less">
	.contact{
		padding-top: 0.9rem;
		background: #FBFBFB;
	}
	.title-box{
		margin-bottom: .6rem;
		img{
			display: block;
			margin: 0 auto;
			width: auto;
			height: .6rem;
		}
	}
	
	.main{
		position: relative;
		z-index: 3;
		width: 100vw;
		overflow: hidden;
		
		.in{
			padding-bottom: 3.6rem;
			display: flex;
			flex-direction: column;
			align-items: center;
		}
		.title{
			width: auto;
			height: .6rem;
			margin-bottom: .8rem;
		}
		.label{
			color: #6E6E6E;
			font-size: .18rem;
			margin-bottom: .04rem;
		}
		.text{
			color: #1E1E1E;
			font-size: .18rem;
			font-weight: bold;
			margin-bottom: .4rem;
		}
		.tel{
			width: auto;
			height: .5rem;
		}
	}
	.pic{
		position: absolute;
		z-index: 2;
		right: -1rem;
		bottom: 0;
		width: 140%;
		height: auto;
	}
	.bg{
		position: absolute;
		z-index: 1;
		right: 0;
		bottom: 0;
		left:0;
		height: 2rem;
		background: #FF4F6A;
	}
</style>